import { useState, type FormEvent } from "react";
import { supabase } from "@/lib/supabase";
import { mapearError } from "@/lib/errores";
import { Boton, Campo, Input } from "@/components/ui";

/** Entrada con código de 6 dígitos al correo (sin contraseña). Solo correos de la lista de Wealth Nation. */
export function Entrar() {
  const [email, setEmail] = useState("");
  const [paso, setPaso] = useState<"correo" | "codigo">("correo");
  const [codigo, setCodigo] = useState("");
  const [cargando, setCargando] = useState(false);
  const [error, setError] = useState<string | null>(null);

  async function pedirCodigo(e: FormEvent) {
    e.preventDefault();
    setError(null); setCargando(true);
    const correo = email.trim().toLowerCase();
    const { error } = await supabase.auth.signInWithOtp({ email: correo, options: { shouldCreateUser: false } });
    setCargando(false);
    if (error) { setError(mapearError(error).mensaje); return; }
    setEmail(correo); setPaso("codigo");
  }

  async function verificar(e: FormEvent) {
    e.preventDefault();
    setError(null); setCargando(true);
    const { error } = await supabase.auth.verifyOtp({ email, token: codigo.replace(/\D/g, ""), type: "email" });
    setCargando(false);
    if (error) setError(mapearError(error).mensaje);
  }

  return (
    <div className="marca-oscura min-h-full text-white">
      <main className="mx-auto flex min-h-full max-w-md flex-col justify-center gap-8 px-6 py-10">
        <div className="flex flex-col items-center gap-6 text-center">
          <img src="/brand/revolution-inc-isotipo-blanco.png" alt="" width={72} height={72} className="h-16 w-16 opacity-95" />
          <div className="flex flex-col gap-3">
            <p className="eyebrow text-acero">Wealth Nation</p>
            <h1 className="text-4xl leading-tight text-[#e8eef3] sm:text-5xl">Tu diseño patrimonial</h1>
            <p className="text-white/65">Entra con el correo con el que estás en Wealth Nation. Te mandamos un código, sin contraseña.</p>
          </div>
        </div>
        <div className="rounded-xl border border-white/10 bg-white p-5 text-tinta shadow-2xl">
          {paso === "correo" ? (
            <form onSubmit={pedirCodigo} className="flex flex-col gap-4">
              <Campo etiqueta="Tu correo" htmlFor="email" error={error ?? undefined}>
                <Input id="email" type="email" inputMode="email" autoComplete="email" required value={email} onChange={(e) => setEmail(e.target.value)} placeholder="tu@correo.com" />
              </Campo>
              <Boton type="submit" tamano="lg" cargando={cargando}>Mandarme el código</Boton>
            </form>
          ) : (
            <form onSubmit={verificar} className="flex flex-col gap-4">
              <Campo etiqueta={`Código que llegó a ${email}`} htmlFor="codigo" ayuda="Revisa también spam o promociones. Vale 10 minutos." error={error ?? undefined}>
                <Input id="codigo" inputMode="numeric" autoComplete="one-time-code" pattern="[0-9]*" maxLength={6} required value={codigo}
                  onChange={(e) => setCodigo(e.target.value)} className="tabular text-center font-mono text-2xl tracking-[.4em]" placeholder="······" />
              </Campo>
              <Boton type="submit" tamano="lg" cargando={cargando} disabled={codigo.replace(/\D/g, "").length !== 6}>Entrar</Boton>
              <Boton type="button" variante="fantasma" onClick={() => { setPaso("correo"); setCodigo(""); setError(null); }}>Usar otro correo</Boton>
            </form>
          )}
        </div>
        <div className="flex flex-col items-center gap-4 text-center">
          <a href="/ejemplo" className="text-sm font-medium text-acero underline underline-offset-4 hover:text-white">Ver un ejemplo sin entrar</a>
          <img src="/brand/revolution-inc-horizontal-blanco.png" alt="Revolution Inc." width={96} height={22} className="h-5 w-auto opacity-70" />
          <p className="text-xs text-white/45">Herramienta educativa de diseño patrimonial. No es asesoría de inversión. <a className="underline" href="/aviso-de-privacidad">Aviso de privacidad</a>.</p>
        </div>
      </main>
    </div>
  );
}
